import './style.css'

let data = false

export function AlertContainer() {
  return (
    <div className={data? 'Alerts Alerts_Show' : 'Alerts'}>
        <div className='Alerts_Con'>
            <div className='Alerts_Title'>{data?.title}</div>
            <div className='Alerts_Message'>{data?.message}</div>
            <button>{data?.btnYes || "Yes"}</button>
            <button onClick={()=>{
                data = false
            }}>{data?.btnYes || "No"}</button>
        </div>
    </div>
  )
}

export function Alerts({title, message, type, btnYes, btnNo}){
    data = {title, message, type, btnYes, btnNo}
}